<template>
  <div>
    <stepper :value="1" />
    <v-row class="name mb-n12 justify-center">
      <v-col lg="6">
        <v-text-field
          class="v-text-field"
          v-model="data.name"
          :label="$t('exercise_name')"
          append-inner-icon="mdi-map-marker"
          autofocus
          outlined
        ></v-text-field
      ></v-col>
    </v-row>

    <v-row class="name mb-n12 justify-center">
      <v-col lg="6">
        <v-autocomplete
          deletable-chips
          item-text="name"
          item-value="id"
          v-model="data.skills"
          chips
          :label="$t('skilles')"
          :items="skillsItems"
          multiple
          outlined
          ref="autocomplete"
          :menu-props="{ closeOnClick: true }"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row class="justify-center mb-4">
      <v-col lg="2"
        ><span>{{ $t("exercise_type") }}</span></v-col
      >
      <v-col cols="12" sm="7" md="6" lg="4">
        <v-sheet elevation="10" rounded="xl">
          <div class="pa-4">
            <v-chip-group
              v-model="data.type"
              active-class="primary--text"
              column
            >
              <v-chip
                v-for="(exercise, index) in types"
                :key="index"
                :value="exercise.value"
              >
                {{ $t(exercise.text) }}
              </v-chip>
            </v-chip-group>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <btns :disable="validate" :action="nextStep" :back="previousStep" />
  </div>
</template>
<script>
import { Skilles } from "@/store/exercise/skilles"; //TODO edit this to hit the Tags api
import { ageGroup } from "@/store/exercise/age-group";
export default {
  props: ["fillData", "types", "skillsItems", "ageItems"],
  data() {
    return {
      Skilles,
      ageGroup,
      agePage: 0,
      searchTerm: "",
      ageGroupItems: [],

      data: {
        name: null,
        serial: null,
        description: null,
        age_group_id: null,
        type: null,
        skills: [],
      },
    };
  },
  methods: {
    nextStep() {
      this.$emit("getData", this.data);
    },
    previousStep() {
      this.$router.go(-1);
    },
    async onIntersectAge() {
      this.agePage += 1;
      await ageGroup.getAgeGroup({ page: this.agePage, name: this.searchTerm });
      this.ageGroupItems = this.ageGroupItems.concat(this.ageItems);
    },
  },
  computed: {
    validate() {

        return (this.data.type == null)
    },
    stopInfinityScroll() {
      return ageGroup.tableData.data.length == 0;
    },
  },
  created() {
    this.onIntersectAge();
  },
  watch: {
    searchTerm(val) {
      if (ageGroup.getAgeState.loading) return;
      setTimeout(() => {
        this.agePage = 1;
        ageGroup.getAgeGroup({ page: this.agePage, name: val });
      }, 500);
    },
  },
};
</script>
